<template>
  <div v-if="isProMonthlyToAnnualBilledMonthlyUpgrade" class="opc-cart-item__text first-capitalize opc-next-renewal">
    {{ $t('billing.order_summary.next_renewal_date') }}
    <vloader :loading="loading" :value="getProAnnualBilledMonthlyNextRenewalDate" />
  </div>
</template>

<script>
import vloader from '@/views/config/shopping-cart/prorated/vloader.vue';
import { BILLING_CYCLE } from '@/common/constants';
import proAnnualBilledMonthlyMixin from '@/plans/ZOOM_MEETING/mixin/pro-annual-billed-monthly';

export default {
  name: 'NextRenewalDate',
  mixins: [proAnnualBilledMonthlyMixin],
  components: { vloader },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    billingCycle: {
      type: String,
      default: BILLING_CYCLE.ANNUAL_TERM_MONTHLY,
    },
  },
};
</script>

<style lang="scss" scoped>
.opc-next-renewal {
  color: var(--day-foreground-foreground-strong, #00031f);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
</style>
